import { ref } from "vue";
import { saveAs } from "file-saver";
import { useSnackbarStore } from "@/store/snackbar.store";
import i18n from "@/plugins/i18n";

const t = i18n.global.t;

export function useDownload() {
  const downloading = ref(false);

  async function downloadFile(fetcher: () => Promise<Blob | undefined>, filename: string) {
    const { showSnackbarSuccess } = useSnackbarStore();
    downloading.value = true;

    try {
      const blob = await fetcher();

      if (!blob) {
        return;
      }

      saveAs(blob, filename);

      showSnackbarSuccess(t("general.download-success"));
    } catch (error) {
      console.error("Download failed", error);
    } finally {
      downloading.value = false;
    }
  }

  return { downloading, downloadFile };
}
